let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9NWgM")).then(() => parcelRequire('6hc7I'));